import toast from 'react-hot-toast';
import api from "../Crypto/axios.js";

export const FETCH_ALL_PRODUCTS = 'FETCH_ALL_PRODUCTS';
export const GET_PRODUCTS_DETAIL = 'GET_PRODUCTS_DETAIL';
export const ADD_NEW_PRODUCT = 'ADD_NEW_PRODUCT';
export const SET_SELECTED_PRODUCT_ROW = 'SET_SELECTED_PRODUCT_ROW';
export const RESET_SELECTED_PRODUCT_ROW = 'RESET_SELECTED_PRODUCT_ROW';
export const PRODUCTS_BY_ID = 'PRODUCTS_BY_ID';
export const STATUS_UPDATED = 'STATUS_UPDATED';
export const CLEAR_DATA = 'CLEAR_DATA';

const initialState = {
  allProducts: [],
  getProductDetails: [],
  productById: [],
  newProduct: [],
  selectedProductRow: {},
  statusUpdate: {},
};

const ProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_PRODUCTS:
      return {
        ...state,
        allProducts: action.payload,
      };
    case GET_PRODUCTS_DETAIL:
      return {
        ...state,
        getProductDetails: action.payload,
      };
    case PRODUCTS_BY_ID:
      return {
        ...state,
        productById: action.payload,
      };
    case ADD_NEW_PRODUCT:
      return {
        ...state,
        newProduct: action.payload,
      };
    case SET_SELECTED_PRODUCT_ROW:
      return {
        ...state,
        selectedProductRow: action.payload,
      };
    case RESET_SELECTED_PRODUCT_ROW:
      return {
        ...state,
        selectedProductRow: {},
      };
    case STATUS_UPDATED:
      return {
        ...state,
        statusUpdate: {},
      };
    case CLEAR_DATA:
      return {
        ...state,
        selectedProductRow: {},
        error: null,
      };
    default:
      return state;
  }
};

export default ProductReducer;

export const fetchAllProducts = (data) => ({
  type: FETCH_ALL_PRODUCTS,
  payload: data,
});
export const productDetails = (data) => ({
  type: GET_PRODUCTS_DETAIL,
  payload: data,
});
export const productById = (data) => ({
  type: PRODUCTS_BY_ID,
  payload: data,
});
export const addNewProducts = (data) => ({
  type: ADD_NEW_PRODUCT,
  payload: data,
});
export const clearData = () => ({
  type: CLEAR_DATA,
});
export const setSelectedProductRow = (data) => ({
  type: SET_SELECTED_PRODUCT_ROW,
  payload: data,
});
export const resetSelectedProductRow = () => ({
  type: RESET_SELECTED_PRODUCT_ROW,
});
export const statusUpdate = () => ({
  type: STATUS_UPDATED,
});

export const getAllProducts = () => {
  return async (dispatch) => {
    try {
      const response = await api.get('/nrcb/ecom/get/products');
      
      if (!response) {
        throw new Error('Failed to get products');
      }
      dispatch(fetchAllProducts(response));
      return response;
    } catch (error) {
      if (error?.response?.status === 404) {
        dispatch(clearData());
      }
      throw error;
    }
  };
};

export const getProductById = (productId) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/nrcb/ecom/get/products/${productId}`);
      if (!response) {
        throw new Error('Failed to get product');
      }
      dispatch(productById(response));
      return response;
    } catch (error) {
      if (error?.response?.status === 404) {
        dispatch(clearData());
      }
      throw error;
    }
  };
};

export const allProductDetails = (userId) => {
  return async (dispatch) => {
    const promise = (async () => {
      try {
        const response = await api.get(
          `/nrcb/ecom/getproducts/details/${userId}`
        );
        if (!response) {
          throw new Error('Failed to get product details');
        }
        dispatch(productDetails(response));
        return response;
      } catch (error) {
        console.error('Failed to fetch product details:', error);
        throw error;
      }
    })();
    return promise;
  };
};

export const addNewProduct = (sellerId, newProduct) => {
  return async (dispatch) => {
    const promise = (async () => {
      try {
        const response = await api.post(
          `/nrcb/ecom/add/product/${sellerId}`,
          newProduct,
          { requiresAuth: true }
        );
        dispatch(addNewProducts(response));
        return response;
      } catch (error) {
        console.error('Error in add new product:', error);
        throw new Error(error.message || 'Failed to add product');
      }
    })();

    toast.promise(promise, {
      loading: 'Adding New Product...',
      success: 'New Product Added',
      error: (error) => {
        return error.message || 'Failed to add product';
      },
    });

    return promise;
  };
};

export const editProduct = (sellerId, updatedProduct, productId) => {  
  return async (dispatch) => {
    const promise = (async () => {
      try {
        const response = await api.post(
          `/nrcb/ecom/update/product/${sellerId}/${productId}`,
          updatedProduct,
          { requiresAuth: true }
        );
        dispatch(addNewProducts(response));
        return response;
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message || error.message || 'Failed';
        console.error('Error:', errorMessage);
        throw new Error(errorMessage);
      }
    })();

    toast.promise(promise, {
      loading: 'Editing data...',
      success: 'Successfully Edited',
      error: (error) => error.message || 'Failed to edit data',
    });

    return promise;
  };
};

export const getProductCount = (productId, priceId) => {
  return async (dispatch) => {
    try {
      const response = await api.get(
        `/nrcb/ecom/get/product/count/${productId}/${priceId}`
      );
      if (!response) {
        const errorMessage = 'Failed to fetch product count';
        console.error('Server error:', response);
        throw new Error(errorMessage);
      }
      return response;
    } catch (error) {
      console.error('Failed to fetch product count:', error);
      throw error;
    }
  };
};

export const statusProducts = (data, userId) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/status/product/${userId}`, data, { requiresAuth: true })
      .then((response) => {
        dispatch(statusUpdate(response));
        return response;
      });

    toast.promise(promise, {
      loading: 'Processing...',
      success: (res) => `Product: ${res?.message || 'Updated successfully'}`,
      error: (error) => {
        console.error('Failed to update status:', error);
        return error.response?.data?.message || 'Failed to update status';
      },
    });

    return promise.catch(() => {
      return { status: 'error', message: 'Failed to update status' };
    });
  };
};

export const featureProducts = (data, userId) => {
  return async (dispatch) => {
    const promise = api
      .post(`/nrcb/ecom/feature/product/${userId}`, data, {
        requiresAuth: true,
      })
      .then((response) => {
        dispatch(statusUpdate(response));
        return response;
      });

    toast.promise(promise, {
      loading: 'Processing...',
      success: (res) => `Product: ${res?.message || 'Updated successfully'}`,
      error: (error) => {
        console.error('Failed to update feature status:', error);
        return (
          error.response?.data?.message || 'Failed to update feature status'
        );
      },
    });

    return promise.catch(() => {
      return { status: 'error', message: 'Failed to update feature status' };
    });
  };
};

